import React, {useState} from "react";
import adminService from "../services/admin.service";
import EventBus from "../common/EventBus";

const ClientDiscountItem = ( {item, subs} ) => {
    const [loading, setLoading] = useState(false);
    const [discount, setDiscount] = useState(item.discount);
    const [editedValue, setEditedValue] = useState(item.discount);
    const [isEdited, setIsEdited] = useState(false);
    const [selectedSub, setSelectedSub] = useState(item.sub);
    const checkValid = (v) => /^\d{0,2}(\.\d{0,2})?$/.test(v) && parseFloat(v) >= 0 && parseFloat(v) < 100;
    const handleInputChange = (e) => {
        const newValue = e.target.value;

        // Check if the new value is a valid decimal between 0 and 100
        const isValid = checkValid(newValue);

        setEditedValue(newValue);
        setIsEdited(newValue !== discount && isValid);
        if (!selectedSub) {
            setSelectedSub(subs[0].id);
        }

    };

    const handleSaveClick = () => {
        if (checkValid(editedValue)) {
            setDiscount(editedValue);
            console.log("new value: ", editedValue, "sub: ", selectedSub);
            setLoading(true);
            adminService.updateDiscount(item.oid, selectedSub, editedValue).then(
                (response) => {
                    item.sub = selectedSub;
                    item.discount = editedValue;
                    setIsEdited(false);
                    setLoading(false);
                },
                (error) => {
                    const _content =
                        (error.response &&
                            error.response.data && error.response.data.message) ||
                        error.message ||
                        error.toString();
                    console.log(error);
                    EventBus.dispatch("showError", _content);
                    setSelectedSub(item.sub);
                    setEditedValue(item.discount);
                    setIsEdited(false);
                    setLoading(false);
                }
            );
        } else {
            EventBus.dispatch("showError", "Invalid discount value. Please enter a valid percentage between 0 and 100.");
        }
    };
    const handleDropdownChange = (e) => {
        setSelectedSub(e.target.value);
        setEditedValue(0);
        setIsEdited(discount !== 0);
    };

    return (
        <tr className="align-middle">
            <td className="fw-medium text-dark">{item.clientName}</td>
            <td className="text-muted small">{item.email}</td>
            <td className="text-muted small">{item.address}</td>
            <td className="text-muted small">{item.city}</td>
            <td>
                <select 
                    value={selectedSub} 
                    onChange={handleDropdownChange}
                    className="form-select form-select-sm bg-light border-0"
                    style={{ width: '180px' }}
                >
                    {subs.map((option) => (
                        <option key={option.id} value={option.id}>
                            {option.name}
                        </option>
                    ))}
                </select>
            </td>
            <td>
                <div className="input-group input-group-sm" style={{ width: '100px' }}>
                    <input 
                        type="text" 
                        value={editedValue} 
                        onChange={handleInputChange} 
                        className="form-control bg-light border-0"
                    />
                    <span className="input-group-text bg-light border-0">%</span>
                </div>
            </td>
            <td>
                <div className="d-flex align-items-center" style={{ minWidth: '80px' }}>
                    {isEdited && !loading && (
                        <button onClick={handleSaveClick} className="btn btn-sm btn-premium rounded-pill px-3 shadow-sm">
                            <i className="bi bi-check2-circle me-1"></i> Save
                        </button>
                    )}
                    {loading && (
                        <span className="spinner-border spinner-border-sm text-primary ms-2"></span>
                    )}
                </div>
            </td>
        </tr>
    );
};

export default ClientDiscountItem;